<template>
  <b-container fluid>
    <b-btn class="create-button" v-b-modal.modal1>Crea Gara a Termine</b-btn>
    <!-- Modal Component -->
    <b-modal id="modal1" size="xl" title="Nuova Gara a termine" @ok="handleOk" ref="modal">
      <b-form>
        <b-row>
          <b-col>
             <b-form-group
                id="input-group-1"
                label="Identificativo Gara a Termine:"
                label-for="idProduct"
              >
              <b-form-input
                id="input-1"
                v-model="form.idProduct"
                placeholder="Scrivi l'identificativo Gara a Termine"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="Perimetro di Flessibilità:"
                label-for="perimeterFlexibility"
              >
              <b-form-input
                id="input-2"
                v-model="form.perimeterFlexibility"
                placeholder="Scrivi il Perimetro di Flessibilità"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
            <b-col>
              <b-form-group
                id="input-group-3"
                label="Livello di tensione Minimo [kV]"
                label-for="levelVoltageMin"
              >
              <b-form-input
                id="input-3"
                v-model="form.levelVoltageMin"
                type="number"
                placeholder="Scrivi il Livello di tensione Minimo [kV]"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-4"
                label="Livello di tensione Massimo [kV]"
                label-for="levelVoltageMax"
              >
              <b-form-input
                id="input-4"
                v-model="form.levelVoltageMax"
                type="number"
                placeholder="Scrivi il Livello di tensione Massimo [kV]"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
         </b-row>

        <b-row>
          <b-col>
              <b-form-group
                id="input-group-9"
                label="Tipo di potenza"
                label-for="powerType"
              >
              <b-form-input
                id="input-9"
                v-model="form.powerType"
                placeholder="Scrivi il Tipo di potenza"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-5"
                label="Potenza minima della Risorsa [MW]"
                label-for="minPowerResource"
              >
              <b-form-input
                id="input-5"
                v-model="form.minPowerResource"
                type="number"
                placeholder="Potenza minima della Risorsa [MW]"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-11"
                label="Direzione di fornitura richiesta"
                label-for="minPowerResource"
              >
              <b-form-select
                v-model="selectedDirSupplyRich"
                :options="optionsDirSupplyRich"
                id="input-group-11-sel"
                label="Direzione di fornitura richiesta"
                label-for="dirSupplyRich"
              >
              <b-form-input
                id="input-11"
                v-model="form.dirSupplyRich"
                placeholder="Direzione di fornitura richiesta"
                required
              ></b-form-input>
              </b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-12"
                label="Quantità richiesta nel perimetro di flessibilità [MW]"
                label-for="qtyRequiredFlexPerimeter"
              >
              <b-form-input
                id="input-12"
                v-model="form.qtyRequiredFlexPerimeter"
                type="number"
                placeholder="Quantità richiesta nel perimetro di flessibilità [MW]"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
             </b-row>

            <b-row>
              <b-col>
               <b-form-group
                id="input-group-13"
                label="Fattore di utilizzazione della disponibilità [p.u.]"
                label-for="AvalilabilityUseFactor"
              >
              <b-form-input
                id="input-13"
                v-model="form.AvalilabilityUseFactor"
                type="number"
                placeholder="Fattore di utilizzazione della disponibilità [p.u.]"
                required
              ></b-form-input>
              </b-form-group>
          </b-col>
          <b-col>
              <b-form-group
                id="input-group-6"
                label="Quantità minima richiesta [MW]"
                label-for="minRequiredQty"
              >
              <b-form-input
                id="input-6"
                v-model="form.minRequiredQty"
                type="number"
                placeholder="Quantità minima richiesta [MW]"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-14"
                label="Numero di quarti d'ora"
                label-for="numQuarterHours"
              >
              <b-form-input
                id="input-14"
                v-model="form.numQuarterHours"
                type="number"
                placeholder="Numero di quarti d'ora"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-7"
                label="Durata minima della fornitura"
                label-for="minSupplyDuration"
              >
              <b-form-input
                id="input-7"
                v-model="form.minSupplyDuration"
                type="number"
                placeholder="Durata minima della fornitura"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
             </b-row>

            <b-row>
              <b-col>
              <b-form-group
                id="input-group-15"
                label="Inizio Finestra di disponibilità"
                label-for="startAvailability"
              >
              <b-form-input
                id="input-15"
                v-model="form.startAvailability"
                type="date"
                placeholder="Inizio Finestra di disponibilità"
                required
              ></b-form-input>
              </b-form-group>
               </b-col>
            <b-col>
              <b-form-group
                id="input-group-16"
                label="Fine Finestra di disponibilità"
                label-for="endAvailability"
              >
              <b-form-input
                id="input-16"
                v-model="form.endAvailability"
                type="date"
                placeholder="Fine Finestra di disponibilità"
                required
              ></b-form-input>
              </b-form-group>
               </b-col>
            <b-col>
               <b-form-group
                id="input-group-17"
                label="Giorni di disponibilità"
                label-for="daysAvailability"
              >
              <b-form-input
                id="input-17"
                v-model="form.daysAvailability"
                type="date"
                placeholder="Giorni di disponibilità"
                required
              ></b-form-input>
              </b-form-group>
               </b-col>
            <b-col>
               <b-form-group
                id="input-group-18"
                label="Ora di inizio disponibilità"
                label-for="startTimeAvailability"
              >
              <b-form-input
                id="input-18"
                v-model="form.startTimeAvailability"
                type="date"
                placeholder="Ora di inizio disponibilità"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
             </b-row>

            <b-row>
              <b-col>
               <b-form-group
                id="input-group-19"
                label="Ora di fine disponibilità"
                label-for="endTimeAvailability"
              >
              <b-form-input
                id="input-19"
                v-model="form.endTimeAvailability"
                type="date"
                placeholder="Ora di fine disponibilità"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
            <b-col>
              <b-form-group
                id="input-group-20"
                label="Gestione dei Giorni Festivi"
                label-for="managePublicHolidays"
              >
              <b-form-input
                id="input-20"
                v-model="form.managePublicHolidays"
                placeholder="Gestione dei Giorni Festivi"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
            <b-col>
              <b-form-group
                id="input-group-8"
                label="Tipo di remunerazione:"
                label-for="typeRemuneration"
              >
              <b-form-input
                id="input-8"
                v-model="form.typeRemuneration"
                placeholder="Scrivi il Tipo di remunerazione"
                required
              ></b-form-input>
              </b-form-group>
              </b-col>
            <b-col>
              <b-form-group
                id="input-group-21"
                label="Prezzo massimo per disponibilità [€/MW/anno]"
                label-for="maxPriceAvailability"
              >
              <b-form-input
                id="input-21"
                v-model="form.maxPriceAvailability"
                type="number"
                placeholder="Prezzo massimo per disponibilità [€/MW/anno]"
                required
              ></b-form-input>
              </b-form-group>
             </b-col>
             </b-row>

            <b-row>
              <b-col>
               <b-form-group
                id="input-group-22"
                label="Prezzo massimo per utilizzo [€/MWh]"
                label-for="maxPriceUse"
              >
              <b-form-input
                id="input-22"
                v-model="form.maxPriceUse"
                type="number"
                placeholder="Prezzo massimo per utilizzo [€/MWh]"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
               <b-form-group
                id="input-group-23"
                label="Prezzo minimo per utilizzo [€/MWh]"
                label-for="minPriceUse"
              >
              <b-form-input
                id="input-23"
                v-model="form.minPriceUse"
                type="number"
                placeholder="Prezzo minimo per utilizzo [€/MWh]"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
           </b-row>
      </b-form>
    </b-modal>
    <b-table striped hover :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="results" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="table-romeflex">
      <template #cell(product)="data">
        <b-button size="sm" @click="data.toggleDetails">
          {{ data.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>
      </template>
      <template #row-details="data">
        <b-card>
          <b-row class="mb-3">
            <b-col><b>Direzione di fornitura richiesta:</b> {{data.item.dirSupplyRich}}</b-col>
            <b-col><b>Quantità richiesta nel perimetro di flessibilità [MW]:</b> {{data.item.qtyRequiredFlexPerimeter}}</b-col>
            <b-col><b>Fattore di utilizzazione della disponibilità [p.u.]:</b> {{data.item.AvalilabilityUseFactor}}</b-col>
            <b-col><b>Quantità minima richiesta [MW]:</b> {{data.item.minRequiredQty}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>Numero di quarti d'ora:</b>{{data.item.numQuarterHours}}</b-col>
            <b-col><b>Durata minima della fornitura:</b>{{data.item.minSupplyDuration}}</b-col>
            <b-col><b>Inizio Finestra di disponibilità:</b>{{data.item.startAvailability}}</b-col>
            <b-col><b>Fine Finestra di disponibilità:</b>{{data.item.minSupplyDuration}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>Giorni di disponibilità:</b>{{data.item.daysAvailability}}</b-col>
            <b-col><b>Ora di inizio disponibilità:</b>{{data.item.startTimeAvailability}}</b-col>
            <b-col><b>Ora di fine disponibilità:</b>{{data.item.endTimeAvailability}}</b-col>
            <b-col><b>Gestione dei Giorni Festivi:</b>{{data.item.managePublicHolidays}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>Tipo di remunerazione:</b>{{data.item.typeRemuneration}}</b-col>
            <b-col><b>Prezzo massimo per disponibilità [€/MW/anno]:</b>{{data.item.maxPriceAvailability}}</b-col>
            <b-col><b>Prezzo massimo per disponibilità [€/MW/anno]:</b>{{data.item.maxPriceUse}}</b-col>
            <b-col><b>Prezzo minimo per utilizzo [€/MWh]:</b>{{data.item.minPriceUse}}</b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="results.length"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </b-container>
</template>

<style>
.create-button {
  margin-bottom: 20px;
  background-color: #af0f6a;
}
.input-date {
  width: 100% !important;
  padding: 0 !important;
  border: 0px !important;
}
.calendar-head h2 {
  font-size: 15px !important;
}
.input-group-text {
  color: #fff;
  background-color: #5A6268;
}
.page-item.active .page-link {
    background-color: #af0f6a;
    border-color: #af0f6a;
}
.btn-light {
    color: #fff;
    background-color: #5A6268;
    border-color: #5A6268;
}
.btn-primary {
    color: #fff;
    background-color: #af0f6a;
    border-color: #af0f6a;
}
.btn-secondary:hover {
    color: #fff;
    background-color: #f7ac51;
    border-color: #f7ac51;
}
.col {
    border: 1px solid rgba(0,0,0,.125);
}
</style>

<script>
import ProductService from '@/services/ProductService'

export default {
  mounted () {
    this.getProducts()
  },
  data () {
    return {
      filter: null,
      sortBy: 'start',
      sortDesc: true,
      results: [],
      fields: [
        { key: 'idProduct', label: 'Id Product', sortable: true },
        { key: 'perimeterFlexibility', label: 'Perimetro di Flessibilità', sortable: true },
        { key: 'levelVoltageMin', label: 'Livello di tensione Minimo [kV]', sortable: true },
        { key: 'levelVoltageMax', label: 'Livello di tensione Massimo [kV]' },
        { key: 'minPowerResource', label: 'Potenza minima della Risorsa [MW]' },
        { key: 'powerType', label: 'Tipo di potenza' },
        { key: 'product', label: '' }
      ],
      form: {
        idProduct: '',
        perimeterFlexibility: '',
        levelVoltageMin: '',
        levelVoltageMax: '',
        minPowerResource: '',
        powerType: '',
        dirSupplyRich: '',
        qtyRequiredFlexPerimeter: '',
        AvalilabilityUseFactor: '',
        minRequiredQty: '',
        numQuarterHours: '',
        minSupplyDuration: '',
        startAvailability: '',
        endAvailability: '',
        daysAvailability: '',
        startTimeAvailability: '',
        endTimeAvailability: '',
        managePublicHolidays: '',
        typeRemuneration: '',
        maxPriceAvailability: '',
        maxPriceUse: '',
        minPriceUse: ''
      },
      selectedDirSupplyRich: null,
      optionsDirSupplyRich: [
        { value: 'salire', text: 'A Salire' },
        { value: 'scendere', text: 'A Scendere' }
      ],
      options: {
        format: 'YYYY-MM-DD hh:mm:ss',
        useCurrent: false
      },
      currentPage: 1,
      perPage: 10
    }
  },
  methods: {
    async getProducts () {
      const response = await ProductService.getProducts()
      console.log('Response ' + JSON.stringify(response.data))
      this.results = response.data
    },
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      this.handleSubmit()
    },
    async handleSubmit () {
      await ProductService.save(this.form)
      await this.getProducts()
      this.$refs.modal.hide()
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    clearAll () {
      this.filter = null
      this.totalRows = this.results.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Product.vue